module.exports = __webpack_public_path__ + "static/img/corfo.97036c64.png";